import ViewTrackingService from 'services/ViewTrackingService';

export default class KidsAccessTrackingService extends ViewTrackingService {
    constructor() {
        super();
    }

    trackModalDisplay() {
        setTimeout(
            () =>
                this.trackState({
                    pageName: '/interstitial/kids/',
                    pageType: 'profile_kidsmode_interstitial',
                }),
            2000,
        );
    }

    trackCtaClick(ctaText) {
        this.trackAction('trackCtaKidsModeInterstitial', {
            pageName: '/interstitial/kids/',
            pageType: 'profile_kidsmode_interstitial',
            ctaText,
        });
    }

    trackModalClose() {
        this.trackAction('trackKidsModeInterstitialClose', {
            pageName: '/interstitial/kids/',
            pageType: 'profile_kidsmode_interstitial',
        });
    }
}
